<template>
  <svg
    class="text-primary"
    :style="computedStyle"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 377.61 380.06"
  >
    <g>
      <path
        d="m295.99,242.66c-59.2,59.2-155.17,59.2-214.37,0l-17.06-17.06L0,290.14l19.99,19.99c93.23,93.23,244.39,93.23,337.63,0l19.99-19.99-64.56-64.53-17.06,17.06Z"
      />
      <path
        d="m141.45,19.61L0,161.05l64.56,64.56,124.25-124.25,124.25,124.25,64.56-64.56L236.17,19.61C223.09,6.54,205.95,0,188.81,0s-34.28,6.54-47.36,19.61"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  size: string | number;
}>();

const computedStyle = computed(() => {
  const sizeValue = typeof props.size === "number" ? `${props.size}px` : props.size;
  return { width: sizeValue, height: sizeValue };
});
</script>
